/**
 * Режим НДС в КП и счёте заказа (паспорт docs/features/kp-vat-mode.md, решения Сергея 15.10.2026).
 *
 *  - INCLUDED — «С НДС»: цена за штуку уже с НДС, в итоге «в том числе НДС» (как было до 15.10.2026);
 *  - ON_TOP — «НДС сверху»: цена без НДС, налог начисляется на сумму — так оформлена большая часть
 *    заказов в 1С:УНФ.
 *
 * Значения — строки, а не enum БД: колонки `quotation_snapshots.vatMode` и `order_invoices.vatMode`
 * — VarChar с дефолтом 'INCLUDED'.
 */
export const VatMode = {
  INCLUDED: 'INCLUDED',
  ON_TOP: 'ON_TOP',
} as const
export type VatMode = (typeof VatMode)[keyof typeof VatMode]

export const VAT_MODES: readonly VatMode[] = [VatMode.INCLUDED, VatMode.ON_TOP]

export const VAT_MODE_LABELS_RU: Record<VatMode, string> = {
  INCLUDED: 'С НДС',
  ON_TOP: 'НДС сверху',
}

/** Новое КП в заявке без прошлых КП — «С НДС». */
export const DEFAULT_VAT_MODE: VatMode = VatMode.INCLUDED

/** Ставка НДС в КП, % (с 01.01.2026 — 22 %). */
export const KP_VAT_RATE = 22

export function isVatMode(v: unknown): v is VatMode {
  return v === VatMode.INCLUDED || v === VatMode.ON_TOP
}
